import axios from "axios";

const personalDevices = () => axios.get(`/personal/api/v1/devices`);
const deviceCompromised = (id, comment) => axios.post(`/personal/api/v1/devices/${id}/compromised`, {comment: comment});

const remember = (deviceID) => axios.post(`/personal/api/v1/devices/${deviceID}/remember`);
const forget = (deviceID) => axios.post(`/personal/api/v1/devices/${deviceID}/forget`);

export default {
  personalDevices,
  deviceCompromised,
  remember,
  forget
};
